// Password policy shared by the create-password and forgot-password flows.
// The minimum length is owned by the backend and arrives on the
// validate-token / verify-otp responses as `passwordLength`; the complexity
// rules below are fixed. DEFAULT_MIN_PASSWORD_LENGTH only applies when the
// API response omits the field.
export const DEFAULT_MIN_PASSWORD_LENGTH = 8;

export const MIN_SPECIAL_CHARS = 3;

const SPECIAL_CHAR = /[^A-Za-z0-9]/g;

// Reads `passwordLength` off an API result, falling back to the default when
// the backend omits it or sends something unusable.
export const resolveMinPasswordLength = (passwordLength) => {
    const parsed = Number(passwordLength);
    if (!Number.isFinite(parsed) || parsed <= 0) return DEFAULT_MIN_PASSWORD_LENGTH;
    return Math.floor(parsed);
};

// Builds the checklist rendered under the password fields. Length is dynamic,
// so the rules have to be rebuilt whenever the backend value changes.
// `t` comes from the calling component so the checklist re-renders on a
// language switch; it falls back to plain interpolation when omitted.
const identity = (key, vars = {}) =>
    key.replace(/{{(\w+)}}/g, (_, name) => vars[name] ?? "");

export const buildPasswordRules = (minLength = DEFAULT_MIN_PASSWORD_LENGTH, t = identity) => [
    {
        key: "len",
        label: t("At least {{count}} characters", { count: minLength }),
        test: (v) => v.length >= minLength,
    },
    {
        key: "special",
        label: t("At least {{count}} special characters", { count: MIN_SPECIAL_CHARS }),
        test: (v) => (v.match(SPECIAL_CHAR) || []).length >= MIN_SPECIAL_CHARS,
    },
    { key: "upper", label: t("One uppercase letter"), test: (v) => /[A-Z]/.test(v) },
    { key: "lower", label: t("One lowercase letter"), test: (v) => /[a-z]/.test(v) },
];
